import { ImportError } from './ImportError'

/**
 * Error that is thrown when a import value is not a valid boolean.
 */
export class ImportBooleanError extends ImportError {
  constructor(message: string) {
    super(message)
    this.name = 'ImportBooleanError'
    Object.setPrototypeOf(this, new.target.prototype)
  }
}
